import {createUpdateSlice} from "../genericCrudSlice";
import {updateWalletApi} from "../../api/entities/wallets";

const updateWalletSlice = createUpdateSlice('wallet', updateWalletApi);
export const {init: initUpdateWallet} = updateWalletSlice.actions;
export const {updateEntity: updateWallet} = updateWalletSlice;
export default updateWalletSlice.reducer;